import { Field, useField } from 'formik'
import PropTypes from 'prop-types'
import ExistingFile from 'ui-toolkit-tailwind/src/ExistingFile'

import FileUpload from '../../Forms/FileUpload'

/**
 * @param {import('../../Forms/FileUpload').FileUploadProps} props
 */
const FormikFileUpload = props => {
	const [field, meta, helpers] = useField(props)
	const { error, touched } = meta
	const hasError = error && touched

	/** @param {File | ExistingFile} file */
	const handleChange = file => {
		helpers.setValue(file)
	}

	return (
		<Field
			as={FileUpload}
			{...field}
			{...props}
			onChange={handleChange}
			invalid={hasError}
			errorMessage={error}
		/>
	)
}

FormikFileUpload.propTypes = {
	className: PropTypes.string,
	name: PropTypes.string.isRequired,
	label: PropTypes.node,
	helperText: PropTypes.string,
	cornerHint: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	disabled: PropTypes.bool,
	pill: PropTypes.bool,
	endpointUrl: PropTypes.string
}

FormikFileUpload.defaultProps = {}

export default FormikFileUpload
